import apiClient from './client'

/**
 * Favorites API Module
 * Manages user's favorite/pinned items (dashboards, metrics, reports, forms)
 * Returns raw JSON:API responses - normalization happens in Redux thunks
 */

/**
 * Fetch the current user's favorites list
 * @returns {Promise<Object>} JSON:API response with favorites data
 */
export async function getFavorites() {
  const response = await apiClient.get('/auth/favorites/', {
    params: { include: null }
  })
  return response.data
}

/**
 * Save/reorder the user's entire favorites list
 * @param {Array<{type: string, id: string, sort_order: number}>} items - Ordered favorites list
 * @returns {Promise<Object>} JSON:API response with updated favorites
 */
export async function saveFavorites(items) {
  const response = await apiClient.put('/auth/favorites/', { items })
  return response.data
}

/**
 * Toggle a single item as favorite/unfavorite
 * @param {string} type - Item type (dashboard, metric, report, form)
 * @param {string|number} id - Item ID
 * @returns {Promise<Object>} JSON:API response with updated favorites list
 */
export async function toggleFavorite(type, id) {
  const response = await apiClient.post('/auth/favorites/toggle/', { type, id })
  return response.data
}
